import { useState, useCallback } from 'react';
import type { InsuranceType } from '../../../../../../services/EncounterService/types/encounterTypes';

/**
 * Hook for managing insurance edit dialog state
 */
export function useInsuranceEditDialog(
  sortedInsurances: InsuranceType[],
  isEncounterCancelled: boolean
) {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedInsuranceId, setSelectedInsuranceId] = useState<string | null>(null);

  // Get the current insurance from the sorted insurances
  const selectedInsurance = selectedInsuranceId
    ? sortedInsurances.find((ins) => ins.id === selectedInsuranceId) || null
    : null;

  const handleRowSelection = useCallback(
    (args: any) => {
      // Don't allow editing if encounter is cancelled
      if (isEncounterCancelled) {
        return;
      }

      if (args.data) {
        const insurance = sortedInsurances.find((ins) => ins.id === args.data.id);
        if (insurance) {
          setSelectedInsuranceId(insurance.id!);
          setEditDialogOpen(true);
        }
      }
    },
    [sortedInsurances, isEncounterCancelled]
  );

  const handleClose = useCallback(() => {
    setEditDialogOpen(false);
    setSelectedInsuranceId(null);
  }, []);

  return {
    editDialogOpen,
    selectedInsurance,
    handleRowSelection,
    handleClose,
  };
}
